<template>
  <unicom-linha class="arquivo-anexo" :espacamento="false">
    <unicom-coluna sm="auto" style="padding-right: 12px">
      <IconeAprovado class="icone" />
    </unicom-coluna>
    <unicom-coluna
      sm="auto"
      alinhamento="center"
      style="height: 100%; padding-bottom: 2px"
    >
      <unicom-linha :espacamento="false" style="height: 100%">
        <unicom-coluna sm="12">
          <div>
            <span class="negrito" style="padding-right: 12px">
              {{ objetoArquivo.nomeArquivo }}
            </span>
            <span class="segunda-cor-fonte">
              {{ objetoArquivo.tamanhoArquivo }}
            </span>
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" alinhamento="end">
          <div style="color: #00995d">
            {{ objetoArquivo.mensagemStatus }} -
            {{ objetoArquivo.dataAlteracao }}
          </div>
        </unicom-coluna>
      </unicom-linha>
    </unicom-coluna>
    <unicom-coluna sm="auto" class="ml-auto" alinhamento="center">
      <unicom-icone
        class="icone-acao"
        :class="{ desativado: !objetoArquivo.baixavel }"
        tooltipNome="Baixar"
        nome="download"
        @click.native="$emit('baixar-arquivo')"
        :tamanho="20"
      />
      <unicom-icone
        class="icone-acao"
        :class="{ desativado: !objetoArquivo.baixavel }"
        tooltipNome="Descriçao"
        nome="edit"
        @click.native="$emit('arquivo-para-descricao', objetoArquivo)"
        :tamanho="20"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import IconeAprovado from "../Icones/IconeAprovado";

export default {
  components: {
    IconeAprovado
  },
  props: {
    objetoArquivo: {
      type: Object,
      default: () => {
        return {
          nomeArquivo: "",
          tamanhoArquivo: 0,
          dataEnvio: "",
          dataAlteracao: "",
          mensagemStatus: "",
          descricao: "",
          baixavel: true,
          mostrarIconeExcluir: true
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./Arquivo.scss";
</style>
